import { debugLog } from "../../utils";
import { HttpStatusCode } from "./HttpStatusCode";

export interface IFetchError {
    status: number;
    message: string;
    redirect?: string;
    requestData?: any;
    data?: any;
}

export class FetchException extends Error implements IFetchError {
    constructor(e: IFetchError) {
        super(e.message);
        this.status = e.status;
        this.data = e.data;
        this.requestData = e.requestData;
        this.redirect = e.redirect;
    }

    data: any;
    requestData: any;
    status: number;
    redirect?: string;
}


export const fetchError = (response: any, message?: string, config?: any): IFetchError => {

    if (!response) {
        if (message === 'Network Error')
            return { status: HttpStatusCode.NOT_FOUND, message: 'Network error - make sure API is running!' }
        return { status: HttpStatusCode.NOT_FOUND, message: message ? message : 'Unknown error' }
    }

    const data: any = response.data;
    const requestData = config ? config.data : undefined;
    const resultMessage = data ? data.Message || data.message : '';
    if (resultMessage)
        message = resultMessage;
    if (!message)
        message = 'Unknown error';

    //debugLog( "Error Response", JSON.stringify(data));
    const ret: IFetchError = { status: response.status, message, requestData, data };

    switch (ret.status) {
        case HttpStatusCode.NOT_FOUND:
            ret.redirect = '/error/404';
            break;
        case HttpStatusCode.UNAUTHORIZED:
            ret.redirect = '/error/401';
            break;
        case HttpStatusCode.BAD_REQUEST:
            if (response.config.method === 'get') {
                if (response.data.errors.hasOwnProperty('id'))
                    ret.redirect = '/error/404';
            }
            break;
        default:
            if (ret.status >= 500)
                ret.redirect = '/error/500';
    }
    debugLog(`>>>>> fetchError(${ret.status}): ${message}`);
    //debugLog(result ? JSON.stringify(result) : 'Data ???');
    return ret;
}

class Error409 extends Error {
    constructor(data: any) {
        super('');
        this.status = HttpStatusCode.CONFLICT;
        data.RowVersion = (data.RowVersion ? data.RowVersion : 'sdfasdf') + 'A';
        this.data = data ? JSON.stringify(data) : null;
    }

    data: any;
    status: number;
}

export function simulateError409(data: any) {
    throw new Error409(data);
}